import React from "react";
import { Link } from "react-router-dom";
import { PROFESSIONS } from "../../data/startPageContent";
import useStartReveal from "../start/useStartReveal";
import "../start/StartProfessions.css";
import "./ForPage.css";

/** One link per unique /for slug (same dedupe as StartFooter). */
export const FOR_LINKS = PROFESSIONS.filter(
  (p, i, arr) => p.slug && arr.findIndex((q) => q.slug === p.slug) === i
);

/**
 * Chip strip linking to the other /for pages. Looks like StartProfessions,
 * but every chip is a <Link> — on a /for page the profession is fixed by the URL.
 */
export default function ForProfessions({ overline, title, sub, currentSlug = null }) {
  const ref = useStartReveal();
  const links = FOR_LINKS.filter((p) => p.slug !== currentSlug);

  return (
    <section id="start-professions" className="st-section st-section--card st-pros fr-pros" aria-labelledby="fr-pros-title">
      <div className="st-container st-reveal" ref={ref}>
        <p className="st-overline st-center">{overline}</p>
        <h2 id="fr-pros-title" className="st-h2 st-center">{title}</h2>
        {sub && <p className="st-sub st-center fr-section-sub">{sub}</p>}
        <nav className="st-pros-chips" aria-labelledby="fr-pros-title">
          {links.map((p) => (
            <Link key={p.slug} to={`/for/${p.slug}`} className="st-chip fr-chip">
              {p.label}
            </Link>
          ))}
        </nav>
      </div>
    </section>
  );
}
